<template>
  <nav class="bg-white border-b border-gray-200 p-4 mb-4">
    <div class="w-full px-4 sm:px-6 lg:px-8 flex justify-between items-center">
      <router-link :to="{ name: 'SmmContent' }" class="text-xl font-semibold place-items-center space-x-2">
        <span>{{ $t('nav.brand') }}</span>
      </router-link>
      <ul class="list flex items-center text-gray-500 text-sm font-semibold">
        <li>
          <router-link :to="{ name: 'User' }"
            class="hover:text-gray-700 p-2 rounded flex items-center space-x-2 font-semibold">
            <span>{{ currentUser?.name }}</span>
          </router-link>
        </li>
        <li class="ml-2 sm:ml-4">
          <button
            type="button"
            :title="$t('nav.logout')"
            class="hover:text-gray-700 p-2 rounded flex items-center"
            @click="logoutUser"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
            </svg>
            <span class="sr-only">{{ $t('nav.logout') }}</span>
          </button>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { mapActions, mapStores } from 'pinia'
import { useAuthStore } from '@/stores/auth.js'

export default {
  computed: {
    ...mapStores(useAuthStore),
    currentUser() {
      return this.authStore?.currentUser
    },
  },
  methods: {
    ...mapActions(useAuthStore, ['logout']),
    logoutUser() {
      this.logout()
        .then(() => {
          this.$router.push({ name: 'Login' })
        })
    },
  },
}
</script>
